export namespace radii {
  export const gridLine = 110;
  export const gridLabel = 110;
  export const cardinalDirectionLabel = 100;
  export const satellitePoint = 90;
}
